
// Import css files
import { Link } from "react-router-dom";

import question from '../../../../../assets/images/questionblog.png';
import expiryclock from '../../../../../assets/images/expiryclock.svg';
import askimg from "../../../../../assets/homeimages/askbtn.svg";
import React from 'react';
import {  useTranslation } from "react-i18next";
import '../articleDetails.css';
import { convertToCanadianDateTime, decodeHtmlEntities } from "../../../../../shared/helper";

const BankingArticleDetailsV1Jsx = (props) => {
  const {
    detailsData
  } = props;
  const { t } = useTranslation();
  return (
    <>
<section className="bankinversiontwodetailblog">
        <div className="container">
          <div className="blogonesection">
            <div className="blogonesectioninner">
              <div className="title"><h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
              <p>{detailsData?.acf?.variant_1?.banner_sectionn?.short_description}</p>
            </div>
            <ul>
              <li>
                <div className="cardsection">
                  <img src={detailsData?.acf?.variant_1?.banner_sectionn?.image1} alt="card" />
                </div>
                <div className="d-flex userdetails">
                  <div className="userphoto">
                    <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                  </div>
                  <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
                </div>
              </li>
              <li>
                <div className="cardsection">
                  <img src={detailsData?.acf?.variant_1?.banner_sectionn?.image2} alt="card" />
                </div>
                <p className="articlepublishdate "><span><img src={expiryclock} alt="clock" /></span>{convertToCanadianDateTime(detailsData?.date)}</p>
              </li>
            </ul>
          </div>
         

          <div className="blogtwosection">
            <div className="row">
              <div className="col-lg-4 col-sm-4">
                <div className="blogtwosectionimge">
                  <img src={detailsData?.acf?.variant_1?.overview_section?.image} alt="blogimage" />
                </div>
              </div>
              <div className="col-lg-8 col-sm-8">
                <div className="blogtwosectiontext">
                  <h4>{detailsData?.acf?.variant_1?.overview_section?.title}</h4>
                  <p>
                    {detailsData?.acf?.variant_1?.overview_section?.description}
                    </p>
                </div>
              </div>
            </div>
          </div>
          <div className="blogtwosection blogthreesection">
            <div className="row">
              <div className="col-lg-8 col-sm-8">
                <div className="blogtwosectiontext">
                  <h4> {detailsData?.acf?.variant_1?.overview_section_2?.title}</h4>
                  <p>
                  {detailsData?.acf?.variant_1?.overview_section_2?.description}
            </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4">
                <div className="blogtwosectionimge">
                  <img src={detailsData?.acf?.variant_1?.overview_section_2?.image} alt="blogimage" />
                </div>
              </div>

            </div>
          </div>
          <div className="blogfoursection">
            <h2>{detailsData?.acf?.variant_1?.compare_section?.title}</h2>
            <table className="table">
              <tr>
                <td></td>
                <td></td>
                <td><div className="tableimage"><img src={detailsData?.acf?.variant_1?.compare_section?.compare_1_image} alt="blogimage" /></div></td>
                <td><div className="tableimage"><img src={detailsData?.acf?.variant_1?.compare_section?.compare_2_image} alt="blogimage" /></div></td>
              </tr>
              {detailsData?.acf?.variant_1?.compare_section?.comparisons.map((item,index) => (

              
              <tr>
                <td>{index+1}</td>
                <td>{item?.heading}</td>
                <td>{item?.features1}</td>
                <td>{item?.features2}</td>
              </tr>
              ))}

              
            </table>
          </div>
          <div className="blogfivesection">
            <h2>{detailsData?.acf?.variant_1?.conclusion_section.title}</h2>
            <div className="blogfivesectioninner">
            <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_1?.conclusion_section.description }}></div>                  
            </div>
          </div>
          <div className="blogsixsection">
            <div className="blogsixsectioninner">
              <h2><span><img src={question} alt="blogicon" /></span>Still Confused?</h2>
              <div className="blogsixsectioninnerbtn">
                <Link to={'/AskTheExpert'}>
                  <div className={`askbutton`}>
                    <p className={`askres mb-0`}>{t("COMMON.ASKTHEEXPERTS")}</p>
                    <img src={askimg} alt="Ask now" />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
  
     
    </>

  );
};

export default BankingArticleDetailsV1Jsx;